export const warningLetter = {
    "in_honor": "En honor a:",
    "letter_reason": "Te enviamos este aviso por no pagar las deudas de la vivienda",
    "debts_title": "Esta es la deuda pendiente",
    "total": "Total:",
    "legal_text_title": "Según el artículo 58 de la ley, tienes responsabilidad absoluta",
    "legal_text": "Si en el plazo de 10 días no liquidas tu deuda, tendremos que iniciar un proceso de reclamación para evitar acciones legales. Te brindamos opciones de pago con plan de cuotas fáciles con tarjeta de crédito",
    "regards": "Saludos.",
    "issuer": "Empresa de gestión y representante de la casa",
    "currency": "ILS",
    "fileName": "debt_warning_letter",
    "one_time": "Para pagos especiales",
    "month": "Para el mes:",
    "apartment": "Número de apartamento:",
    "address": "Dirección:",
    "date": "Fecha:",
    "title": "Asunto: Participación en los gastos de mantenimiento de los bienes comunes",

    "new": {
        "title": "ב – תכרעמ םימולשתה לש",
        "date": "תאריך",
        "to": "לכבוד",
        "address": "כתובת",
        "noticeBeforeLegalAction": "התראה לפני נקיטת הליכים משפטיים",
        "listItems": {
            "first": "לע יפ םימושירה תרבחב ונ רט ם ורדסוה ימולשת דעו תיבה לש ך",
            "second": "בוחה ול ו דע תיבה וניה םאתהב טוריפל לבטב ה ןלהלש :",
            "third": "נציגינו פנו מספר פעמים בבקשה להסדרת החוב, אולם טרם הוסדר התשלום כמתחייב בחוק",
            "forth": "החוב גורם עיכובים וקשיים מרובים בתפקוד הבניין כסדרו ובהחזקתו השוטפת. זאת, כאשר הדירה שבבעלותך נהנית מניהול הבניין, על חשבונם של יתר הדיירים. ",
            "fifth": "על פי סעיף 58  א' לחוק המקרקעין, כל בעל דירה חייב להשתתף בהוצאות הדרושות להחזקתו התקינה ולניהולו של הרכוש המשותף ולא הוא צפוי לעונשים הקבועים בחוק.",
            "sixth": "עליך להסדיר את התשלום",
            "sixthHighlited": "באופן מידי ובכל מקרה לא יאוחר משבוע ימים ממועד מכתב זה.",
            "seventh": "באם החוב לא יוסדר במסגרת הזמן שהוזכרה, תוגש כנגדך תביעה משפטית. במסגרת זו, בנוסף לתשלום החוב כנקוב לעיל, יתווספו לתביעה הוצאות ההליכים המשפטיים, לרבות אגרת בית משפט בסך 694 ש״ח, שכר טרחת עו״ד, ריבית והצמדה וכל הוצאה נוספת אשר תפסקנה ע״י בית המשפט." ,
            "eighth": "במידה והחוב הוסדר על פי הפירוט המופיע להלן טרם קבלת מכתב זה, ראו הודעה זו כמבוטלת. ",
            "ninth": "לבירורים ניתן לפנות לבלינק בטלפון 03-5090045 ",
            "tenth": "התראה נוספת לא תישלח. ",
            "eleventh": "שיטות לתשלום - ישירות לחשבון הבנק המשותף של ועד הבית ",
            "eleventhFirst": "תשלום בכרטיס אשראי",
            "eleventhTwo": "תשלום ישירות דרך הבנק ",
        },
        "total": "סה״כ לתשלום",
        "extraInfo": "*לנוחיותך, ניתן לפרוס את הסכום לתשלומים נוחים דרך מוקד בלינק 03-5090045 ",
        "table": {
            "payment": "תשלום עבור",
            "monthInfo": "פירוט חודשים",
            "sum": "סכום",
            "firstRow": "תשלום ועד חודשי",
            "secondRow": "תשלום מיוחד"
        }
    }
};
